// extracted by mini-css-extract-plugin
export default {"card":"J6-z"};